export default {
  fullSchedules: null,
  extraPersonnel: null,
  userFullSchedules: null
};
